import React from "react";

const ManualsFill = props => (
  <svg viewBox="0 0 23 19" fill="none" {...props}>
    <path
      d="M21.422.79c-2.149.116-6.406.546-9.024 2.147a.61.61 0 00-.312.508v14.22c0 .468.508.741.937.546 2.696-1.367 6.602-1.758 8.516-1.836.664-.04 1.172-.586 1.172-1.21V1.96c.039-.664-.586-1.211-1.29-1.172zm-10.86 2.147C7.946 1.337 3.689.908 1.54.79.836.75.25 1.297.25 1.961v13.203c0 .625.508 1.172 1.172 1.211 1.914.078 5.82.469 8.515 1.836.43.195.938-.078.938-.547V3.445a.61.61 0 00-.313-.507z"
      fill="currentColor"
    />
  </svg>
);

export default ManualsFill;
